import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import { call, join, put, select } from "redux-saga/effects";
import { setAppLoading } from "redux/slices/authTokenSlice";
import { setSearchLoading } from "redux/slices/focusItemsSlice";
import { setSearchData, setPredictionSearchProcessing } from "redux/slices/predictionSlice";
import { setPredictionProcessing } from "redux/slices/predictionSlice";
import { setPredictionData } from "redux/slices/predictionSlice";
import { setPredictionLoading } from "redux/slices/predictionSlice";
import { deleteCandidate, deletePredictionCampaign, deletePredictionCategory, getCandidates, getPredictionCampaigns, getPredictionCampaign, getPredictionCategoryInfo, getPredictionResult, patchCandidate, patchPredictionCampaign, patchPredictionCategories, postCandidate, postPredictionCampaign, postPredictionCategory } from "../requests/predictionService";

export function* handleGetPredictionCampaign(action) {
  const type = "campaign";
  try {
    yield put(setPredictionLoading(type))
    const { data: awardCampaignList } = yield call(() => getPredictionCampaigns(action.payload))
    yield put(setPredictionData({ data: awardCampaignList.data, type, page: awardCampaignList.page, totalPage: awardCampaignList.total_pages }))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setPredictionData({ error: errMsg, type }))
  }
}


export function* handleCreatePredictionCampaign(action) {
  const type = "campaign";
  const {
    campaign: { data }
  } = yield select((state) => state.prediction)

  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    const { data: campaignList } = yield call(() => postPredictionCampaign(action.payload))
    yield put(setPredictionData({ data: [...data, campaignList.data], type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}

export function* handleUpdatePredictionCampaign(action) {
  const type = "campaign";

  const {
    campaign: { data }
  } = yield select((state) => state.prediction)

  const { prediction_campaign_id, payload } = action.payload;
  const { searchResult } = yield select((state) => state.prediction);

  try {
    const isStatusToggle = 'active' in payload
    if (isStatusToggle) {
      yield put(setAppLoading(true))
    }
    if (isEmpty(searchResult.data)) {
      yield put(setPredictionProcessing({ type, processing: true }))
      const { data: campaign } = yield call(() => patchPredictionCampaign(prediction_campaign_id, payload))
      const updatedPredictionCampaignList = data?.map((x) => {
        if (x?.id === prediction_campaign_id) {
          return campaign.data
        } else {
          return x;
        }
      })
      yield put(setPredictionData({ data: updatedPredictionCampaignList, type }))
    } else {
      yield put(setPredictionSearchProcessing(true))
      const { data: campaign } = yield call(() => patchPredictionCampaign(prediction_campaign_id, payload))
      yield put(setSearchData({ data: campaign.data }))
    }
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
    yield put(setPredictionSearchProcessing(false))
    yield put(setAppLoading(false))
  }
}

export function* handleDeletePredictionCampaign(action) {
  const type = "campaign";

  const {
    campaign: { data }
  } = yield select((state) => state.prediction)

  try {
    const { searchResult } = yield select((state) => state.prediction);

    if (isEmpty(searchResult.data)) {
      yield put(setPredictionProcessing({ type, processing: true }))
      yield call(() => deletePredictionCampaign(action.payload))
      const updatedPredictionCampaignList = data.filter((x) => x.id !== action.payload)
      yield put(setPredictionData({ data: updatedPredictionCampaignList, type }))
      toast.success("Campaign deleted successfully")
    } else {
      yield put(setPredictionSearchProcessing(true))
      yield call(() => deletePredictionCampaign(action.payload))
      yield put(setSearchData({ data: {} }))
      toast.success("Campaign deleted successfully")
    }

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
    yield put(setPredictionSearchProcessing(false))
  }
}

export function* handleGetPredictionCategoryInfo(action) {
  const type = "category";

  try {
    yield put(setPredictionLoading(type))
    const { data: awardList } = yield call(() => getPredictionCategoryInfo(action.payload))
    yield put(setPredictionData({ data: awardList.data, type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }
}


export function* handleCreatePredictionCategory(action) {
  const type = "category";

  const {
    category: { data }
  } = yield select((state) => state.prediction)
  const { campaign_id, payload } = action.payload;

  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    const { data: award } = yield call(() => postPredictionCategory(campaign_id, payload))
    yield put(setPredictionData({ data: [...data, award.data], type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}


export function* handleUpdatePredictionCategory(action) {
  const type = "category";

  const {
    category: { data }
  } = yield select((state) => state.prediction)

  const { id, payload } = action.payload;
  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    const { data: category } = yield call(() => patchPredictionCategories(id, payload))
    const updatedAwardList = data?.map((x) => {
      if (x?.id === id) {
        return category.data
      } else {
        return x;
      }
    })
    yield put(setPredictionData({ data: updatedAwardList, type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}

export function* handleRemovePredictionCategory(action) {
  const type = "category";
  const {
    category: { data }
  } = yield select((state) => state.prediction)

  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    yield call(() => deletePredictionCategory(action.payload))
    const updatedAwardList = data.filter((x) => x.id !== action.payload)
    yield put(setPredictionData({ data: updatedAwardList, type }))
    toast.success("Category deleted successfully")
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}


export function* handleCreateCandidates(action) {
  const type = "candidate";

  const {
    candidate: { data }
  } = yield select((state) => state.prediction)
  const { id, payload } = action.payload;
  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    const { data: nominee } = yield call(() => postCandidate(id, payload))

    yield put(setPredictionData({ data: [nominee.data, ...data], type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}



export function* handleUpdateCandidate(action) {
  const type = "candidate";

  const {
    candidate: { data }
  } = yield select((state) => state.prediction)

  const { id, payload } = action.payload;
  try {
    yield put(setPredictionProcessing({ type, processing: true }))
    const { data: nominee } = yield call(() => patchCandidate(id, payload))
    const updatedAwardList = data?.map((n) => {
      if (n.id === id) {
        return nominee.data
      } else {
        return n;
      }
    })

    yield put(setPredictionData({ data: updatedAwardList, type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}


export function* handleGetCadidates(action) {
  const type = "candidate";
  try {
    yield put(setPredictionLoading(type))
    const { data: nominees } = yield call(() => getCandidates(action.payload))
    yield put(setPredictionData({ data: nominees.data, type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }
}

export function* handleRemoveCandidate(action) {
  const type = "candidate";

  const {
    candidate: { data }
  } = yield select((state) => state.prediction)

  try {
    const { id } = action.payload;
    yield put(setPredictionProcessing({ type, processing: true }))
    yield call(() => deleteCandidate(id))
    const updateCandidate = data.filter((x) => x.id !== id)
    yield put(setPredictionData({ data: updateCandidate, type }))
    toast.success("Candiate deleted successfully")
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setPredictionProcessing({ type, processing: false }))
  }
}



export function* handleGetPredictionResults(action) {
  const type = "result";
  try {
    yield put(setPredictionLoading(type))
    const { data: result } = yield call(() => getPredictionResult(action.payload))
    yield put(setPredictionData({ data: result.data, type }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }
}


export function* handleGetSearchResults(action) {
  try {
    yield put(setSearchLoading())
    const { data: result } = yield call(() => getPredictionCampaign(action.payload))
    yield put(setSearchData({ data: result.data }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setSearchData({ error: errMsg }))
  }
}

